<template>
    <div class="container-count" :class="[lClass]" @click="nothing">
        <div
            :class="['symbol',count<=min|| disabled?('disabled '+lDisabledClass):('abled '+ lSymbolClass)]"
            @click.stop="reduceTap"
        >
            <span>-</span>
        </div>
        <input
            class="count"
            :class="lCountClass"
            :disabled="disabled"
            type="number"
            :value="count"
            @blur="onBlur"
        />
        <div
            :class="['symbol',lSymbolClass,count>=max|| disabled?('disabled '+lDisabledClass):('abled '+ lSymbolClass)]"
            @click="addTap"
        >
            <span>+</span>
        </div>
    </div>
</template>

<script>
import { mixinsFunc } from '../mixins/MixinsFunc'
export default {
    name: 'CountSelector',
    props: {
        num: {
            type: [Number, String],
            default: 1
        },
        max: {
            type: Number,
            default: 10000
        },
        min: {
            type: Number,
            default: 1
        },
        step: {
            type: Number,
            default: 1
        },
        disabled: Boolean,
        lClass: {
            type: String,
            default: ''
        },
        lSymbolClass: {
            type: String,
            default: ''
        },
        lCountClass: {
            type: String,
            default: ''
        },
        lDisabledClass: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            count: 0
        }
    },
    mounted() {
        this.count = this.num
    },
    methods: {
        ...mixinsFunc,
        doNothing() {},

        onBlur(e) {
            let value = event.target.value
            setTimeout(() => {
                this.blurCount(value)
            }, 50)
        },

        blurCount(value) {
            if (value) {
                if (value > this.max)
                    this.setData({
                        count: this.max
                    })
                else if (value < this.min)
                    this.setData({
                        count: this.min
                    })
                else
                    this.setData({
                        count: value
                    })
            } else {
                this.setData({
                    count: this.count
                })
            }
            let detail = {
                count: this.count,
                type: 'blur',
                ...this.$attrs
            }
            this.$emit('lintap', detail)
        },

        reduceTap() {
            if (this.count <= this.min || this.disabled) return
            let distance = this.count - this.step
            if (distance <= this.min) {
                this.count = this.min
            } else {
                this.count -= this.step
            }
            this.setData({
                count: this.count
            })
            let detail = {
                count: this.count,
                type: 'reduce',
                ...this.$attrs
            }
            this.$emit('lintap', detail)
        },

        addTap(e) {
            if (this.count >= this.max || this.disabled) {
                return
            }

            let distance = this.count + this.step
            if (distance >= this.max) {
                this.count = this.max
            } else {
                this.count += parseInt(this.step)
            }
            let detail = {
                count: this.count,
                type: 'add',
                ...this.$attrs
            }
            this.$emit('lintap', detail)
        }
    }
}
</script>
<style lang='stylus'>
.container-count
    display: flex
    flex-direction: row
.symbol
    height: 28px
    width: 28px
    display: inline-block
    vertical-align: middle
    text-align: center
    line-height: 28px
    font-size: 21px
.disabled
    background-color: #f3f3f3
    color: #c4c9d2
.abled
    background-color: #ecf1f8
    color: #596c8e
.count
    height: 28px
    width: 32px
    font-size: 12px
    color: #596c8e
    background: #f6f7f9
    margin: 0 2px
    text-align: center
</style>
